"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: '',
  components: {},
  mixins: [],
  props: {
    writeOffData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogTableVisible: false,
      // 弹窗是否显示
      verifyCount: 1 // 核销次数
    };
  },
  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destoryed: function destoryed() {},
  methods: {
    // 开启弹窗
    openDialog: function openDialog() {
      this.dialogTableVisible = true;
    },
    // 关闭弹窗
    closeDialog: function closeDialog() {
      this.dialogTableVisible = false;
      this.verifyCount = 1;
      // this.$emit('handleSearchList');
    },
    // 核销
    writeOff: (0, _validate.Debounce)(function () {
      var _this = this;
      {
        if (!this.verifyCount) {
          this.$message.error('核销次数不能为空！');
          return;
        }
        var param = {
          orderNo: this.writeOffData.orderNo,
          verifyCount: this.verifyCount
        };
        (0, _order.writeUpdateApi)(param).then(function () {
          _this.$message.success('核销成功');
          _this.closeDialog();
          _this.$emit('handleSearchList');
          _this.verifyCount = 1;
        });
      }
    })
  }
};